import { render, staticRenderFns } from "./tenant.vue?vue&type=template&id=93c9e44c&scoped=true&"
import script from "./tenant.ts?vue&type=script&lang=ts&"
export * from "./tenant.ts?vue&type=script&lang=ts&"
import style0 from "./tenant.scss?vue&type=style&index=0&id=93c9e44c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c9e44c",
  null
  
)

export default component.exports